import Vue from 'vue'
import DDErrorHandlerPlugin from './dd-error-handler/dd-error-handler.plugin'
import DDErrorHandler from './dd-error-handler/dd-error-handler'

declare module 'vue/types/vue' {
  export interface Vue {
    $error: DDErrorHandler
  }
}

Vue.use(DDErrorHandlerPlugin)
